import { Button, Menu, MenuButton, MenuItemOption, MenuList, MenuOptionGroup } from '@chakra-ui/react';
import { ReactElement } from 'react';
import { Icon } from 'shared-components';
import { ApplicantOfferRequirementTaskLevel, ApplicantOfferRequirementTaskStatus, SettableTaskLevel } from 'types';
import { faAngleDown } from '@fortawesome/pro-regular-svg-icons';
import { readableTaskLevels, taskLevelSelectStyle, taskLevelConfig } from './requirement-rows/constants';
import { useTranslation } from "react-i18next";

interface TaskTypeMenuProps {
  currentLevel: ApplicantOfferRequirementTaskLevel;
  isDisabled?: boolean;
  isOfferIssued: boolean;
  onLevelChange: (level: SettableTaskLevel) => void;
  onExempt: () => void;
}

export function TaskTypeMenu({
  currentLevel,
  isDisabled = false,
  isOfferIssued,
  onLevelChange,
  onExempt,
}: TaskTypeMenuProps): ReactElement {
    const { t } = useTranslation('common');
  const styleProps = taskLevelSelectStyle[currentLevel] ?? { colorScheme: 'gray' };

  const handleChange = (value: string | string[]): void => {
    if (value === ApplicantOfferRequirementTaskStatus.Exempt) {
      onExempt();
    } else {
      onLevelChange(value as SettableTaskLevel);
    }
  };

  return (
    <Menu placement="bottom-end">
      <MenuButton
        as={Button}
        isDisabled={isDisabled}
        leftIcon={<Icon icon={taskLevelConfig[currentLevel]?.icon} className="colorful-icon" />}
        rightIcon={<Icon icon={faAngleDown} />}
        variant="status"
        size="sm"
        {...styleProps}
      >
        {readableTaskLevels[currentLevel] ?? currentLevel}
      </MenuButton>
      <MenuList>
        <MenuOptionGroup type="radio" value={currentLevel} onChange={handleChange}>
          {!isOfferIssued && (
            <MenuItemOption value={ApplicantOfferRequirementTaskLevel.PreOffer}>
              {taskLevelConfig[ApplicantOfferRequirementTaskLevel.PreOffer].label}
            </MenuItemOption>
          )}
          <MenuItemOption value={ApplicantOfferRequirementTaskLevel.Condition}>
            {taskLevelConfig[ApplicantOfferRequirementTaskLevel.Condition].label}
          </MenuItemOption>
          <MenuItemOption value={ApplicantOfferRequirementTaskLevel.PreEnrolment}>
            {taskLevelConfig[ApplicantOfferRequirementTaskLevel.PreEnrolment].label}
          </MenuItemOption>
          <MenuItemOption value={ApplicantOfferRequirementTaskStatus.Exempt}>{t('common:exempt')}</MenuItemOption>
        </MenuOptionGroup>
      </MenuList>
    </Menu>
  );
}
